/* eslint-disable */

import { HiX } from 'react-icons/hi';
import Links from './components/Links';
import {
    renderThumb,
    renderTrack,
    renderView,
} from 'components/scrollbar/Scrollbar';
import { Scrollbars } from 'react-custom-scrollbars-2';
import routes from 'routes';
import routesBuyer from 'routesBuyer';
import Card from 'components/card';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdFormatListBulleted, MdBarChart, MdSettings, MdHelpOutline, MdDescription, MdOutlineWhatsapp } from 'react-icons/md';
import KelvinLogo from 'assets/kelvin.png';

const SidebarHorizon = (props: {
    open: boolean;
    onClose: React.MouseEventHandler<HTMLSpanElement>;
    variant?: string;
}) => {
    const { open, onClose, variant } = props;
    const nav = useNavigate();
    const ASSISTANCE_WHATSAPP_URL = 'https://wa.me/447458107868';
    const KELVIN_URL = 'https://www.go-kelvin.com/lp-kelvin?utm_source=partenaire&utm_medium=leadrs';

    useEffect(() => {
        // if (localStorage.getItem("user-type") === "seller") {
        //   setRoutes(routes);
        // }
    }, []);

    return (
        <div
            className={`sm:none duration-175 linear fixed !z-50 min-h-full transition-all md:!z-50 lg:!z-50 xl:!z-0 ${
                variant === 'auth' ? 'xl:hidden' : 'xl:block'
            } ${open ? '' : '-translate-x-full'}`}
        >
            <Card
                extra={`w-[285px] ml-3 sm:mr-4 sm:my-4 h-[96.5vh] m-7 !rounded-[20px]`}
            >
                <Scrollbars
                    autoHide
                    renderTrackVertical={renderTrack}
                    renderThumbVertical={renderThumb}
                    renderView={renderView}
                >
                    <div className="relative flex h-full flex-col justify-between">
                        <div>
                            <span
                                className="absolute right-4 top-4 block cursor-pointer xl:hidden"
                                onClick={onClose}
                            >
                                <HiX />
                            </span>
                            <div className="mt-[68px] hidden h-px bg-leadrs-stroke lg:block" />
                            <div className="mb-2">
                                {localStorage.getItem('user-type') ===
                                    'buyer' && (
                                    <div className="flex flex-col gap-2 px-3 mt-6">
                                        <button
                                            className="flex w-full items-center gap-2 rounded-xl bg-leadrs-yellow-soft px-4 py-2.5 font-geist text-xs font-medium text-leadrs-yellow-focus hover:opacity-80 transition-opacity"
                                            onClick={() => {
                                                if (window.innerWidth < 567)
                                                    onClose({} as any);
                                                nav('/create-order');
                                            }}
                                        >
                                            <MdFormatListBulleted className="h-4 w-4 flex-shrink-0" />
                                            Faire une commande
                                        </button>
                                        <button
                                            className="flex w-full items-center gap-2 rounded-xl bg-leadrs-green-soft px-4 py-2.5 font-geist text-xs font-medium text-leadrs-green-focus hover:opacity-80 transition-opacity"
                                            onClick={() => {
                                                if (window.innerWidth < 567)
                                                    onClose({} as any);
                                                nav('/purchase-order');
                                            }}
                                        >
                                            <MdBarChart className="h-4 w-4 flex-shrink-0" />
                                            Faire un ordre d'achat
                                        </button>
                                    </div>
                                )}
                                {localStorage.getItem('user-type') ===
                                    'seller' && (
                                    <div className="flex flex-col gap-2 px-3 mt-6">
                                        <button
                                            className="flex w-full items-center gap-2 rounded-xl bg-leadrs-yellow-soft px-4 py-2.5 font-geist text-xs font-medium text-leadrs-yellow-focus hover:opacity-80 transition-opacity"
                                            onClick={() => {
                                                if (window.innerWidth < 567)
                                                    onClose({} as any);
                                                nav('/seller-offer');
                                            }}
                                        >
                                            <MdFormatListBulleted className="h-4 w-4 flex-shrink-0" />
                                            Ajouter une offre
                                        </button>
                                    </div>
                                )}
                            </div>
                            {/* Nav item */}
                            {localStorage.getItem('user-type') === 'buyer' ? (
                                <div className="flex flex-col h-full">
                                    <p className="ml-[28px] mt-6 font-geist text-[11px] font-semibold uppercase tracking-widest text-leadrs-text-soft">
                                        Gestion
                                    </p>
                                    <ul className="ml-[10px] mt-2 pt-1">
                                        <Links routes={routesBuyer} onClick={onClose} />
                                    </ul>
                                    <div className="mt-4 mx-3 border-t border-leadrs-stroke" />
                                    <ul className="ml-[10px] mt-3">
                                        <li
                                            className="my-[3px] flex cursor-pointer items-center px-8 py-2 text-leadrs-text-soft hover:text-leadrs-text transition-colors"
                                            onClick={() => { if (window.innerWidth < 567) onClose({} as any); nav('/faq'); }}
                                        >
                                            <MdDescription className="h-5 w-5 flex-shrink-0" />
                                            <span className="ml-2 font-geist text-xs font-medium">FAQ</span>
                                        </li>
                                        <li
                                            className="my-[3px] flex cursor-pointer items-center px-8 py-2 text-leadrs-text-soft hover:text-leadrs-text transition-colors"
                                            onClick={() => { if (window.innerWidth < 567) onClose({} as any); nav('/settings'); }}
                                        >
                                            <MdSettings className="h-5 w-5 flex-shrink-0" />
                                            <span className="ml-2 font-geist text-xs font-medium">Mon compte</span>
                                        </li>
                                        <li
                                            className="my-[3px] flex cursor-pointer items-center px-8 py-2 text-leadrs-green-focus hover:opacity-80 transition-opacity"
                                            onClick={() => { if (window.innerWidth < 567) onClose({} as any); nav('/assistance'); }}
                                        >
                                            <MdOutlineWhatsapp className="h-5 w-5 flex-shrink-0" />
                                            <span className="ml-2 font-geist text-xs font-medium">Assistance</span>
                                        </li>
                                    </ul>
                                    <div className="mx-3 mt-4 rounded-2xl bg-leadrs-purple-soft p-4">
                                        <div className="mb-2 flex items-center gap-3">
                                            <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl bg-white">
                                                <img src={KelvinLogo} alt="Kelvin" className="h-6 w-6 object-contain" />
                                            </div>
                                            <p className="font-geist text-sm font-semibold text-leadrs-purple-focus">Besoin d&apos;un accompagnement ?</p>
                                        </div>
                                        <p className="font-geist text-xs text-leadrs-purple-focus leading-relaxed opacity-80">
                                            RGE, besoin de gagner du temps sur chaque RDV? Un seul outil pour préparer chaque RDV, chiffrer rapidement les projets de rénovation énergétique et les aides.
                                        </p>
                                        <button
                                            className="mt-2 font-geist text-sm font-medium text-leadrs-purple-focus underline underline-offset-2 hover:opacity-70 transition-opacity"
                                            onClick={() => window.open(KELVIN_URL, '_blank')}
                                        >
                                            C&apos;est par ici.
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="flex flex-col h-full">
                                    <p className="ml-[28px] mt-6 font-geist text-[11px] font-semibold uppercase tracking-widest text-leadrs-text-soft">
                                        Gestion
                                    </p>
                                    <ul className="ml-[10px] mt-2 pt-1">
                                        <Links routes={routes} onClick={onClose} />
                                    </ul>
                                    <div className="mt-4 mx-3 border-t border-leadrs-stroke" />
                                    <ul className="ml-[10px] mt-3">
                                        <li
                                            className="my-[3px] flex cursor-pointer items-center px-8 py-2 text-leadrs-text-soft hover:text-leadrs-text transition-colors"
                                            onClick={() => { if (window.innerWidth < 567) onClose({} as any); nav('/faq'); }}
                                        >
                                            <MdDescription className="h-5 w-5 flex-shrink-0" />
                                            <span className="ml-2 font-geist text-xs font-medium">FAQ</span>
                                        </li>
                                        <li
                                            className="my-[3px] flex cursor-pointer items-center px-8 py-2 text-leadrs-text-soft hover:text-leadrs-text transition-colors"
                                            onClick={() => { if (window.innerWidth < 567) onClose({} as any); nav('/settings'); }}
                                        >
                                            <MdSettings className="h-5 w-5 flex-shrink-0" />
                                            <span className="ml-2 font-geist text-xs font-medium">Mon compte</span>
                                        </li>
                                        <li
                                            className="my-[3px] flex cursor-pointer items-center px-8 py-2 text-leadrs-green-focus hover:opacity-80 transition-opacity"
                                            onClick={() => { if (window.innerWidth < 567) onClose({} as any); nav('/assistance'); }}
                                        >
                                            <MdOutlineWhatsapp className="h-5 w-5 flex-shrink-0" />
                                            <span className="ml-2 font-geist text-xs font-medium">Assistance</span>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </Scrollbars>
            </Card>
        </div>
    );
};

export default SidebarHorizon;
